import { QUELog, DeviceInfo, QPInfoManager } from 'qunar-react-native';
const { isWeb, isMini } = DeviceInfo;
// 通用参数定义
export const TYPE_PAGE = 'page'; // 页面

export const OPER_CLICK = 'click';
export const OPER_SHOW = 'show';
export const OPER_ENTER = 'enter';

export const BIZ_TYPE_PP = 'pp';

export const ORDER_ENTRANCE_TRUE = '1'; // 生单入口
export const ORDER_ENTRANCE_FALSE = '0'; // 非生单入口

export const MODULE_PAGE = 'page'; // 页面
export const MODULE_BUTTON = 'button'; // 按钮
export const MODULE_HEAD = 'head'; // 头部
export const MODULE_CARD = 'card'; // 卡片

export const PAGE_ORDER_LIST = 'orderList';

export default class PPLogUtil {
    public static generateCommonLog(
        title: string,
        isOrderEntr: string,
        operType: string,
        module: string,
        extObject: any,
        position?: string,
        
        page?:string,
        appcode?:string,
        id?:string,
        key?:string,
    ) {
        QPInfoManager.getQpInfo(
            'cmn_order_rn',
            (qpInfo: { version: number }) => {
                const { version } = qpInfo || {};
                const logObject = {
                    title,
                    isOrdEntr: isOrderEntr,
                    operType,
                    module,
                    ext: extObject,
                    bizType: BIZ_TYPE_PP,
                    page: page || PAGE_ORDER_LIST,
                    operTime: new Date().getTime(),
                    qpVer: version,
                    position,
                    appcode,
                    id,
                    key
                };
                const statisticsStr = `CARD_ENTRANCE_START####${JSON.stringify(
                    logObject
                )}####CARD_ENTRANCE_END`;
                if (!(isWeb || isMini)) {
                    QUELog.logOrigin(statisticsStr);
                }
            },
            () => {}
        );
    }

    // 无痕订单-提示弹框
    public static privateOrderModal(title: string, operType: string,id: string,key:string) {
        // { "title": "privateOrderModalShow", "isOrdEntr": "1", "operType": "show", "module": "Service_Tips", "ext": { }, "bizType": "pp", "page": "Privacy_order", "operTime": 1605583981731, "qpVer": "5162", "position": "position", "appcode": "cmn_component_order", "id": "1", "key": "pp/Privacy_order/Service_Tips/show/1" }

        const logObject = {
            operType,
            module: 'Service_Tips',
            bizType: BIZ_TYPE_PP,
            page: 'Privacy_order',
            operTime: String(new Date().getTime()),
            appcode: 'cmn_component_order',
            id,
            key
        };
        const statisticsStr = `CARD_ENTRANCE_START####${JSON.stringify(
            logObject
        )}####CARD_ENTRANCE_END`;
        // todo web&wx
        if(!(isWeb || isMini)){
            QUELog.logOrigin(statisticsStr);
        }


    }
    //砍价标签
    public static priceBubbleBtn( operType: string,id: string,ext:any) {
        const logObject = {
            operType,
            module: 'orderBtn',
            bizType: 'pp',
            page: 'order_rn_main',
            operTime: String(new Date().getTime()),
            appcode: 'cmn_order_rn,cmn_component_order',
            id,
            ext,
            key:`pp/order_rn_main/orderBtn/${operType}/${id}`
        };
        const statisticsStr = `CARD_ENTRANCE_START####${JSON.stringify(
            logObject
        )}####CARD_ENTRANCE_END`;
        // todo web&wx
        if(!(isWeb || isMini)){
            QUELog.logOrigin(statisticsStr);
        }
    }
    // wx关注弹窗
    public static orderWxPopup( operType: string,id: string,ext:any) {
        const logObject = {
            operType,
            module: 'bindNotice',
            bizType: 'pp',
            page: 'order_rn_main',
            operTime: String(new Date().getTime()),
            appcode: 'cmn_order_rn,cmn_component_order',
            id,
            ext,
            key:`pp/order_rn_main/bindNotice/${operType}/${id}`
        };
        const statisticsStr = `CARD_ENTRANCE_START####${JSON.stringify(
            logObject
        )}####CARD_ENTRANCE_END`;
        // todo web&wx
        if(!(isWeb || isMini)){
            QUELog.logOrigin(statisticsStr);
        }
    }
    // 进入全部订单列表页
    public static orderListEnterLog(title: string, isLogin: string,source: string) {
        const extObject = {
            isLogin,
            source
        };
        this.generateCommonLog(title, ORDER_ENTRANCE_TRUE, OPER_ENTER, MODULE_PAGE, extObject);
        // console.log('新订单enter')
    }

    // 订单卡片展示
    public static orderCardShowOrClickLog(
        operType: string,
        syscode: string,
        orderNo: string,
        businessType: string,
        source = '',
        position: string,
    ) {
        const extObject = {
            syscode,
            orderNo,
            businessType,
            source,
        };
        this.generateCommonLog('order_card', ORDER_ENTRANCE_TRUE, operType, MODULE_CARD, extObject, position);

    }

    // "root":{
    //     "bizType":"pp"
    //     "module":"Privacy_order"
    //     "appcode":"cmn_order_rn"
    //     "page":"Privacy_order"
    //     "id":"2"
    //     "operType":"click"
    //     "title":"无痕订单点击"
    //     "key":"pp/Privacy_order/Privacy_order/click/2"
    //     "operTime":"*"
    //     }
    public static privateOrderCardShowOrClick(
        isClick: boolean
    ) {
        const logInfo = {
            bizType: "pp",
            module: "Privacy_order",
            appcode: "cmn_order_rn",
            page: "Privacy_order",
            id: isClick? "2": "1",
            operType: isClick? OPER_CLICK: OPER_SHOW,
            title: isClick? "无痕订单点击": "无痕订单展示",
            key: isClick? "pp/Privacy_order/Privacy_order/click/2": "pp/Privacy_order/Privacy_order/show/1",
            operTime: String(new Date().getTime()),
        }
        const statisticsStr = `CARD_ENTRANCE_START####${JSON.stringify(
            logInfo
        )}####CARD_ENTRANCE_END`;
        // console.log(statisticsStr);

        // alert(statisticsStr)
        // todo web&wx
        if(!(isWeb || isMini)){
            QUELog.logOrigin(statisticsStr);
        }
    }

    // "root":{10 items
    //     "ext":{1 item
    //     "result":"0，1"
    //     }
    //     "bizType":"pp"
    //     "module":"password"
    //     "appcode":"cmn_order_rn"
    //     "page":"Privacy_order"
    //     "id":"1"
    //     "operType":"resp"
    //     "title":"密码关联订单"
    //     "key":"pp/Privacy_order/password/resp/1"
    //     "operTime":"*"
    //     }
    public static logForRelatedPrivateOrder(isRelateSuccess: boolean){
        const logInfo = {
            bizType: "pp",
            module: "password",
            appcode: "cmn_order_rn",
            page: "Privacy_order",
            id: "1",
            operType: "resp",
            title: "密码关联订单",
            key: "pp/Privacy_order/password/resp/1",
            operTime: String(new Date().getTime()),
            ext: {
                result: isRelateSuccess? "1": "0"
            }
        }
        const statisticsStr = `CARD_ENTRANCE_START####${JSON.stringify(
            logInfo
        )}####CARD_ENTRANCE_END`;
        // console.log(statisticsStr);

        // alert(statisticsStr)
        // todo web&wx
        if(!(isWeb || isMini)){
            QUELog.logOrigin(statisticsStr);
        }
    }

    // 摇一摇埋点
    // "root":{10 items
    //     "ext":{1 item
    //     "source":"*"
    //     }
    //     "bizType":"pp"
    //     "module":"shake"
    //     "appcode":"cmn_order_rn"
    //     "page":"Privacy_order"
    //     "id":"1"
    //     "operType":"req"
    //     "title":"摇一摇手势"
    //     "key":"pp/Privacy_order/shake/req/1"
    //     "operTime":"*"
    //     }
    public static logForShakeInOrderList(source: string) {
        const logInfo = {
            ext: {
                source: source
            },
            bizType: "pp",
            module: "shake",
            appcode: "cmn_order_rn",
            page: "Privacy_order",
            id: "1",
            operType: "req",
            title: "摇一摇手势",
            key: "pp/Privacy_order/shake/req/1",
            operTime: String(new Date().getTime()),
        }
        const statisticsStr = `CARD_ENTRANCE_START####${JSON.stringify(
            logInfo
        )}####CARD_ENTRANCE_END`;
        // console.log(statisticsStr);

        // alert(statisticsStr)
        // todo web&wx
        if(!(isWeb || isMini)){
            QUELog.logOrigin(statisticsStr);
        }

    }

    // 订单卡片按钮点展
    public static orderButtonClickOrShowLog(
        title: string,
        operType: string,
        syscode: string,
        orderNo: string,
        businessType: string,
        source = '',
        position: string,
        action?: any
    ) {
        const extObject = {
            syscode,
            orderNo,
            businessType,
            source,
            pid: action.pid ? action.pid : 'none'
        };
        this.generateCommonLog(title, ORDER_ENTRANCE_TRUE, operType, MODULE_BUTTON, extObject, position, 'orderList', 'cmn_component_order', '1', `pp/orderList/button/${operType}/1`);
    }

    // 顶部TAB点击与业务分类TAB点击
    public static orderHeadClickLog(title: string, extObject: any) {
        this.generateCommonLog(title, ORDER_ENTRANCE_FALSE, OPER_CLICK, MODULE_HEAD, extObject, );
    }

    public static serviceProgressShowOrClickLog(params: {
        businessType: string,
        cardPosition: string,
        position: string,
        title: string,
        operType: string,
    }) {
        const extObject = {
            businessType: params.businessType,
            cardPosition: params.cardPosition,
        };
        QPInfoManager.getQpInfo(
            'cmn_order_rn',
            (qpInfo: { version: number }) => {
                const { version } = qpInfo || {};
                const logObject = {
                    title: params.title,
                    isOrdEntr: '0',
                    operType: params.operType,
                    module: 'service',
                    ext: extObject,
                    bizType: BIZ_TYPE_PP,
                    page: 'order_rn_main',
                    operTime: new Date().getTime(),
                    qpVer: version,
                    position: params.position,
                };
                const statisticsStr = `CARD_ENTRANCE_START####${JSON.stringify(
                    logObject
                )}####CARD_ENTRANCE_END`;
                if(!(isWeb || isMini)){
                    QUELog.logOrigin(statisticsStr);
                }
            },
            () => {}
        );
    }

    // CARD_ENTRANCE_START####{"ext":{"businessType":"*","cardPosition":"*"},"isOrdEntr":"1","bizType":"pp","module":"serviceBtn","qpVer":"*","page":"order_rn_main","position":"0,1,2","operType":"show,click","title":"*","operTime":"*"}####CARD_ENTRANCE_END
    public static logForQuickService(params: {
        businessType: string,
        cardPosition: string,
        position?: string,
        title: string,
        operType: string,
    }) {
        const extObject = {
            businessType: params.businessType,
            cardPosition: params.cardPosition,
        };
        QPInfoManager.getQpInfo(
            'cmn_order_rn',
            (qpInfo: { version: number }) => {
                const { version } = qpInfo || {};
                const logObject = {
                    title: params.title,
                    isOrdEntr: '1',
                    operType: params.operType,
                    module: 'serviceBtn',
                    ext: extObject,
                    bizType: BIZ_TYPE_PP,
                    page: 'order_rn_main',
                    operTime: String(new Date().getTime()),
                    qpVer: version,
                    position: params.position,
                };
                const statisticsStr = `CARD_ENTRANCE_START####${JSON.stringify(
                    logObject
                )}####CARD_ENTRANCE_END`;
                if(!(isWeb || isMini)){
                    QUELog.logOrigin(statisticsStr);
                }
            },
            () => {}
        );
    }

    public static logForKeyWatcher(params: {
        operType: string,
        id: string,
        ext?: any,
        time?: number
    }) {
        const logObj = {
            id: params.id,
            operType: params.operType,
            module: 'watcher',
            bizType: 'pp',
            appcode: 'cmn_component_order',
            page: 'orderList',
            ext: params.ext,
            key: `pp/orderList/watcher/${params.operType}/${params.id}`,
            operTime: String(new Date().getTime()),
            time: params.operType == 'monitor'? (params.time || ''): undefined
        };
        const statisticsStr = `CARD_ENTRANCE_START####${JSON.stringify(
            logObj
        )}####CARD_ENTRANCE_END`;
        if(!(isWeb || isMini)){
            QUELog.logOrigin(statisticsStr);
        }

    }
}
